import React from 'react'
import PropTypes from 'prop-types'
import LoadingView from './LoadingView'
import FormView from './FormView'
import DetailsView from './DetailsView'
import SuccessView from './SuccessView'
import NewCardView from './NewCardView'
import NewAddressView from './NewAddressView'
import { SIGNUP_VIEWS } from './'

/**
 * Determines which view is to be rendered and how to render it.
 *
 * @returns {function} Component
 */
const SubscriptionFormViews = ({
  subscriptionForm,
  user,
  changeView,
  currentView,
  detailsDocument,
}) => {
  let View = LoadingView

  // Props to pass on.
  const viewProps = {
    user,
    detailsDocument,
    changeView,
    subscriptionForm,
  }

  if (currentView === SIGNUP_VIEWS.loading) {
    View = LoadingView
  } else if (currentView === SIGNUP_VIEWS.form) {
    View = subscriptionForm.isInitialized
      ? FormView
      : LoadingView
  } else if (currentView === SIGNUP_VIEWS.details) {
    View = DetailsView
  } else if (currentView === SIGNUP_VIEWS.success) {
    View = SuccessView
  } else if (currentView === SIGNUP_VIEWS.cardForm) {
    View = NewCardView

    // Add an onSuccess callback to the view that triggers a refresh of the payment sources
    // and then selects the newly created payment source, and then switches back to the previous
    // view.
    viewProps.onSuccess = () => {
      subscriptionForm.refreshPaymentSources((sources) => {
        const prevIds = subscriptionForm.paymentSources.map(({ id }) => id)
        const newSource = sources.find(({ id }) => prevIds.indexOf(id) < 0)

        if (newSource) {
          subscriptionForm.onFormChange({
            target: {
              name: 'walletSourceId',
              value: newSource.id,
            },
          })
        }
      })

      changeView(SIGNUP_VIEWS.form, false)
    }
  } else if (currentView === SIGNUP_VIEWS.addressForm) {
    View = NewAddressView

    // Add an onSuccess callback to the view that triggers a refresh of the address book
    // and then selects the newly created address, and then switches back to the previous
    // view.
    viewProps.onSuccess = () => {
      subscriptionForm.refreshAddresses((addresses) => {
        const prevIds = subscriptionForm.addresses.map(({ id }) => id)
        const newAddress = addresses.find(({ id }) => prevIds.indexOf(id) < 0)

        if (newAddress) {
          subscriptionForm.onFormChange({
            target: {
              name: 'shippingAddressId',
              value: newAddress.id,
            },
          })
        }
      })

      changeView(SIGNUP_VIEWS.form, false)
    }
  }

  return <View {...viewProps} />
}

SubscriptionFormViews.propTypes = {
  subscriptionForm: PropTypes.shape({}).isRequired,
  detailsDocument: PropTypes.shape({}).isRequired,
  currentView: PropTypes.oneOf([
    'loading',
    'details',
    'form',
    'success',
    'newCard',
    'newAddress',
  ]).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
    platinum: PropTypes.bool,
  }).isRequired,
  changeView: PropTypes.func.isRequired,
}

export default SubscriptionFormViews
